import store from '../store';
import router from '../router';
import { getQueryString } from "@/utils/ruoyi";
const pdfPath = '/twoPage/file';   // pdf的详情页面；

// 根据导航内容获取menu_info
export function setMenuInfoPath(crumbs, id) {
    if (Array.isArray(crumbs)) {
        let crumbsInfo = menuInfoMethods(crumbs, 'name');
        const menuInfo = crumbsInfo.map(item => item.id).join(',');
        const path = crumbsInfo[crumbsInfo.length - 1].path || pdfPath;
        const url = `${path}?menu_info=${menuInfo}&id=${id}`;
        if (url) {
            router.push(url)
        }
        return;
    }
    return false;
}

// 根据menu_info获取导航内容
export function setPageRouter() {
    // 根据menu_info获取导航内容
    let routerInfo = menuInfoMethods( getQueryString('menu_info').split(','), 'id');
    // 获取跳转地址
    const { path, name, url } = routerInfo[routerInfo.length - 1];
    let toUrl = path ? path : pdfPath;
    // 拼接参数
    const params = ['id', 'flag', 'menu_info'];
    params.forEach(item => {
        toUrl += toUrl.includes('?') ? '&' : '?';
        toUrl += `${item}=${getQueryString(item) || ''}`
    })
    return {
        routerInfo,
        toUrl,
        url,
        id: getQueryString('id')
    };
}


export function menuInfoMethods(arr, prop) {
    const treePage = store.getters.pageRouter;
    let routerInfo = [];
    arr.forEach((item, index) => {
        if (index === 0) {
            const findItem = treePage.find(d => d[prop] == item);
            if (findItem) {
                routerInfo.push(findItem);
            }
        } else {
            const findItem = routerInfo[index - 1].children.find(d => d[prop] == item) || "";
            if (findItem) {
                routerInfo.push(findItem);
            }
        }
    })
    return routerInfo;
}